import React from "react";
import "./Dashboard_buckets_card.css";

function Dashboard_buckets_card({imgSrc,number,heading_text,text}) {
  return (
    <>
      <section className="Dashboard_buckets_card">
        <div className="row">
          <div className="col-7">
            <div className="text_holder">
              <h2>{number}</h2>
              <h4>{heading_text}</h4>
              <p>{text}</p>
            </div>
          </div>

          <div className="col-5">
            <div className="img_holder">
              <img
                src={imgSrc}
                alt="bucket image"
                className="bucket_img"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Dashboard_buckets_card;
